import { Globals } from "../CoreApp/Globals";

export function IsHiddenFolder(folderName) {
  switch (folderName) {
    case "System":
      return true;
    case "Temp":
      return Globals._wsMgr.fAdminLogin == false;
  }

  return false;
}
